import { mapAvailabilityData, mapStoreAvailability } from 'connectors/availability/Availability';
import { mapProductPriceData, mapProductPricesData } from 'connectors/price/Prices';
import { VirtualSetFragmentApi } from 'graphql/generated';
import { AvailabilityStatusEnum } from 'types/availability';
import { VirtualSetProductType } from 'types/product';

export type VirtualSetType = {
    products: VirtualSetProductType[];
};

export const mapVirtualSetApiData = (
    apiData: VirtualSetFragmentApi,
    mainProductUuid: string,
    currencyCode: string,
): VirtualSetType => {
    return {
        products: apiData.products
            .slice()
            .sort((a, b) => (b.uuid === mainProductUuid ? 1 : a.uuid === mainProductUuid ? -1 : 0))
            .filter((product) => product.availability.status === AvailabilityStatusEnum.inStock)
            .map((product) => ({
                __typename: 'VirtualSetProduct',
                id: product.id,
                uuid: product.uuid,
                name: product.name,
                slug: product.slug,
                fullName: product.fullName,
                price: mapProductPriceData(product.price, currencyCode),
                prices: mapProductPricesData(product.prices, currencyCode),
                image: product.images[0] ?? null,
                b2bPaymentDiscount: product.b2bPaymentDiscount ? Number(product.b2bPaymentDiscount) : null,
                b2bMinimumProductOrder: product.b2bMinimumProductOrder ? Number(product.b2bMinimumProductOrder) : null,
                maximumOrderableQuantity: Number(product.maximumOrderableQuantity),
                availability: mapAvailabilityData(product.availability),
                defaultStoreAvailability: product.defaultStoreAvailability
                    ? mapStoreAvailability(product.defaultStoreAvailability)
                    : null,
                deliveryDaysFromCentralStore: product.deliveryDaysFromCentralStore,
            })),
    };
};
